import { c as _c } from "react/compiler-runtime";
import useProductLocalStock from 'data-hooks/useProductLocalStock';

// Get stock data for this product
const usePDPLocalStock = (t0, t1) => {
  const $ = _c(6);
  const {
    id,
    slug,
    productOptions,
    optionsEnriched
  } = t0;
  const {
    skip: skipAll
  } = t1;
  let t2;
  if ($[0] !== id || $[1] !== optionsEnriched || $[2] !== productOptions || $[3] !== skipAll || $[4] !== slug) {
    t2 = {
      slug,
      id,
      options: productOptions,
      optionsEnriched,
      skipAll
    };
    $[0] = id;
    $[1] = optionsEnriched;
    $[2] = productOptions;
    $[3] = skipAll;
    $[4] = slug;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const stock = useProductLocalStock(t2);
  return stock;
};
export default usePDPLocalStock;